import { useEffect } from "react"
import { useStores } from "stores/root-store"
import { storageName } from "shared/constants/storage-constant"
import { Link, useNavigate } from "react-router-dom"
import { rootStore } from "stores/root-store"
import BomForm from "components/bom/dialog/bom-form"
import { observer } from "mobx-react-lite"
import CommonPage from "components/common/common-page"
import { Typography } from "@mui/material"
import { CommonHyperlink } from "components/common-styles"

const BillOfMaterials = observer(() => {
  const navigate = useNavigate()
  const { BillOfMaterialStore } = useStores()

  useEffect(() => {
    rootStore.setOpenForm(false)
    rootStore.setScreenTitle("Bill of Materials Search")
    BillOfMaterialStore.resetData()
    return () => rootStore.setScreenTitle("")
  }, [])

  const handleClickOpen = () => {
    rootStore.setScreenTitle("")
    rootStore.setOpenForm(true)
  }

  const handleClose = () => {
    rootStore.setScreenTitle("Bill of Materials Search")
    BillOfMaterialStore.setSelectedId("")
    rootStore.setOpenForm(false)
  }

  const handleSave = () => {
    handleClose()
    if (BillOfMaterialStore.searchText) BillOfMaterialStore.loadData()
  }

  const handleRowClicked = params => {
    navigate(`/bom/${encodeURIComponent(params.row["ITEM"])}`)
  }

  const filterData = []

  const hiddenColumns = {}

  const columns = [
    {
      field: "ITEM",
      headerName: "Item",
      flex: 1,
      minWidth: 200,
      renderCell: params => <CommonHyperlink to={`/bom/${encodeURIComponent(params.value)}`}>{params.value}</CommonHyperlink>,
    },
    {
      field: "ITEM_DESC",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "QUANTITY_UM",
      headerName: "Quantity UM",
      width: 150,
    },
    {
      field: "REVISION_NUM",
      headerName: "Revision Number",
      width: 150,
    },
  ]

  if (rootStore.openForm) return <BomForm onSave={handleSave} onClose={handleClose} />

  return (
    <>
      <CommonPage
        DataStore={BillOfMaterialStore}
        filterData={filterData}
        searchPlaceholder={"Search for Item code or Item description."}
        filterStorageName={storageName.bomFilter}
        allowArchivalSearch={false}
        columns={columns}
        hiddenColumns={hiddenColumns}
        gridStorageName={storageName.bomColumn}
        searchRequiredWarningMsg="Search for a specific BOM and select a filter to narrow down your search"
        noDataMsg="Your search returned no results. Please contact ops@estorelogistics.com.au if you believe this error is incorrect."
        exportFileName="Express_BOM"
        handleAddClicked={handleClickOpen}
        handleRowClicked={handleRowClicked}
      />
    </>
  )
})

export default BillOfMaterials
